
//  Home Category Slider

$(document).ready(function(){
  $(".carousel-one").owlCarousel({
    loop: true,
    margin: 10,
    nav: true, // enable by default
    items: 8,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/1084/8390/files/arrow-lft-white.svg?v=1762930752" alt="Previous" />',
      '<img src="https://cdn.shopify.com/s/files/1/1084/8390/files/arrow-right-white.svg?v=1762930843" alt="Next" />'
    ],
    responsive: {
      0: {
        items: 3,
        nav: true,
        loop: false
      },
      575: {
        items: 4,
        nav: true,
        loop: false
      },
      767: {
        items: 6,
        nav: true,
        loop: false
      },
      1000: {
        items: 8,
        nav: true,
        loop: false
      },
      1200: {
        items: 8,
        nav: true,
        loop: false
      }
    }
  });
});


  //  Slider 2

  $(document).ready(function(){
  $(".carousel-two").owlCarousel({
    loop: true,
    margin: 10,
    nav: true, // enable by default
    items: 5,
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/1084/8390/files/arrow-lft-white.svg?v=1762930752" alt="Previous" />',
      '<img src="https://cdn.shopify.com/s/files/1/1084/8390/files/arrow-right-white.svg?v=1762930843" alt="Next" />'
    ],
    responsive: {
      0: {
        items: 1,
        nav: true,
        loop: false
      },
      575: {
        items: 2,
        nav: true,
        loop: false
      },
      767: {
        items: 3,
        nav: true,
        loop: false
      },
      1000: {
        items: 4,
        nav: true,
        loop: false
      },
      1200: {
        items: 5,
        nav: true,
        loop: false
      }
    }
  });
});
 



